// src/oura/lib/reportTitle.ts
//
// The title of an uploaded report (#4031).
//
// The upload dialog used to PUT the file's name into the Title box the moment a
// file was chosen. Anyone who then typed a real title had it run into the file
// name, with no space between: a stored title read "October test report (staff
// test)oura staff test report". The file name is now only a SUGGESTION, shown
// as the box's placeholder and used when the box is left empty, and the box
// itself starts empty so nothing can be typed into the middle of it.

/** A title a person could have written, from a file name: no extension, separators as spaces. */
export function titleFromFileName(fileName: string): string {
    return fileName.replace(/\.pdf$/i, "").replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();
}

/**
 * The title that is sent: what was typed, or else the suggestion from the file.
 * Empty when neither exists, which keeps the upload button off.
 */
export function reportTitle(typed: string, fileName: string | null): string {
    const own = typed.trim();
    if (own) return own;
    return fileName ? titleFromFileName(fileName) : "";
}
